export default "__VITE_ASSET__Be8a3ABo__"